export default __webpack_public_path__ + "static/media/research.a0ad5ba0.svg";